import React, {useState,useEffect} from "react"
import { MdOutlineDoubleArrow } from "react-icons/md";


 const  LatestNews = () => {

     const [news,setNews] = useState(null)
     const [loading,setLoading] = useState(true)
     const [error,setError] = useState(null)

  useEffect(() =>  {

      const getNews = async() =>  {
              
             try {

                const resp= await fetch(`https://www.teluguone.com/news_api/catNewsPaginate?catId=${25}&start=${0}&total=${8}`)
                if (!resp.ok) throw new Error(`Latest News Fetching Response was not Ok`)
                const res = await resp.json()
                setNews(res.morenews)



             } catch (error) {
                    
              setNews(null)
              setError(error)
              console.log(error.message)
              
             }finally {
              setLoading(false)
             }

         }


         getNews()

  },[])


   if (loading) {
      
       return <ul>
           {Array(8).fill("0").map((item,index) => <li key={index} ><a  href='' className='notranslate'  translate="no"  ><MdOutlineDoubleArrow  className='top-latest-icon' />Loading News ...</a></li>   )}
       </ul>
   }
   if (error) {
      return <ul>
           {Array(8).fill("0").map((item,index) => <li key={index} ><a  href='' className='notranslate'  translate="no"  ><MdOutlineDoubleArrow  className='top-latest-icon' /></a></li>   )}
       </ul>
   }

   return <ul>
         {news && news.map((item,index) => <li key={index} ><a  href={item.url_link || ''} className='notranslate'  translate="no"  target="_blank" rel="noopener noreferrer" ><MdOutlineDoubleArrow  className='sidebar-latest-icon' />{item.title ? item.title : ''}</a></li>   )}
       </ul>




}

export default LatestNews;